import { render, staticRenderFns } from "./prevent_treat_obj.vue?vue&type=template&id=e3f6fa72&"
import script from "./prevent_treat_obj.vue?vue&type=script&lang=js&"
export * from "./prevent_treat_obj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports